import styled from 'styled-components';

import breakpoint from '../../utils/breakpoint';
import theme from '../../themes/phoenix/theme';

const Card = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuoteBladeCard = styled(Card)`
  flex: "1 1 100%";
  border: ${theme.borders.card};
    margin: 10px;
    padding: 30px;
  ${breakpoint('md')(`
    margin: 10px;
    padding: 35px;
  `)}
  ${breakpoint('lg')(`
    margin: 20px;
    padding: 60px;
  `)}
`;

export const FileCard = styled(Card)`
  flex: "1 1 100%";
  margin: 10px;
  padding: 30px 35px;
  margin: 0px 25px 15px 0px;
  ${breakpoint('md')(`
    padding: 35px 35px;
  `)}
  ${breakpoint('lg')(`
    padding: 60px 38px;
  `)}
`;

export const ContactTableCard = styled(Card)`
  padding: 1rem 1.5rem;
`;

export const QuoteMenuCard = styled(Card)`
  flex: "1 1 100%";
  border: ${theme.borders.card};
  margin: 10px;
  padding: 30px;
  ${breakpoint('lg')(`
    padding: 35px;
  `)}
  ${breakpoint('xl')(`
    margin: 20px;
    padding: 60px;
  `)}
`;
